import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import DocsLayout from './components/Layout/DocsLayout'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import Welcome from './pages/Welcome'
import QuickStart from './pages/QuickStart'
import Apps from './pages/PlatformCapabilities/Apps'
import Registry from './pages/PlatformCapabilities/Registry'
// import CloudStorage from './pages/PlatformCapabilities/CloudStorage' // Hidden for now
import Database from './pages/PlatformCapabilities/Database'
import VPS from './pages/PlatformCapabilities/VPS'
import Billing from './pages/Account/Billing'
import Usage from './pages/Account/Usage'
import APIKeys from './pages/Resources/APIKeys'
import FAQ from './pages/Resources/FAQ'
import Support from './pages/Resources/Support'
import Community from './pages/Resources/Community'
import VSCodeExtension from './pages/Resources/VSCodeExtension'
import CLI from './pages/Resources/CLI'

function App() {
  return (
    <Router>
      <ScrollToTop />
      <DocsLayout>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/quick-start" element={<QuickStart />} />
          <Route path="/platform-capabilities/apps" element={<Apps />} />
          <Route path="/platform-capabilities/registry" element={<Registry />} />
          {/* Cloud Storage - Hidden for now */}
          {/* <Route path="/platform-capabilities/cloud-storage" element={<CloudStorage />} /> */}
          <Route path="/platform-capabilities/database" element={<Database />} />
          <Route path="/platform-capabilities/vps" element={<VPS />} />
          <Route path="/account/billing" element={<Billing />} />
          <Route path="/account/usage" element={<Usage />} />
          <Route path="/resources/api-keys" element={<APIKeys />} />
          <Route path="/resources/vscode-extension" element={<VSCodeExtension />} />
          <Route path="/resources/cli" element={<CLI />} />
          <Route path="/resources/faq" element={<FAQ />} />
          <Route path="/resources/support" element={<Support />} />
          <Route path="/resources/community" element={<Community />} />
        </Routes>
      </DocsLayout>
    </Router>
  )
}

export default App
